<template>
  <div>
    <!-- banner -->
    <banner :bannerImgs="bannerImgs" class="bannerFather">
      <template v-slot:context>
        <h2 class>核心技术</h2>
        <p class="descri">旨在实现一种智能：听得清楚、感知灵敏、</p>
        <p class="descri">识别准确、响应迅速</p>
      </template>
    </banner>

    <div class="w100 swsb">
      <div class="container">
        <h2>声纹识别技术</h2>
        <p>即说话人识别，通过说话人的声音信号来自动识别人的技术</p>
      </div>
    </div>

    <!-- 算法特点 -->
    <div class="w100 sftd">
      <div class="title">
        <h4>算法特点</h4>
      </div>
      <div class="floatcontent clearfix">
        <div class="floatitem">
          <img src="@/assets/images/sf1.png" />
          <div>
            <p>
              <span class="dot"></span>
              采用声学和语音音素两种方法建立DNN模型，提高了低信噪比信道下的识别准确率，相比常规识别方法降低了等错误率；
            </p>
          </div>
        </div>
        <div class="floatitem">
          <img src="@/assets/images/sf2.png" />
          <div>
            <p>
              <span class="dot"></span>
              采用Source-normalization的多信道算法训练技术，不同信道场景创建单一模型，提高了同一说话人在不同信道下识别鲁棒性问题；
            </p>
          </div>
        </div>
        <div class="floatitem">
          <img src="@/assets/images/sf3.png" />
          <div>
            <p>
              <span class="dot"></span>
              采用灵活分段技术将说话人在不同场景下的短时语音进行融合与训练，提高了多人讲话下说话人识别稳定性；
            </p>
          </div>
        </div>
        <div class="floatitem">
          <img src="@/assets/images/sf4.png" />
          <div>
            <p>
              <span class="dot"></span>
              采用改进的PLDA技术对信道进行补偿，提高了识别过程的信道鲁棒性；
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 技术优势 -->
    <TechnicalHighlights class="technical" :list="techDes">
      <h4>技术优势</h4>
    </TechnicalHighlights>

    <div
      class="yuyin"
      :style="{ background: 'url(' + require('@/assets/images/coretesc/js_bg_1.png') + ') no-repeat center center'}"
    >智能语音技术</div>
    <!-- 其它主要核心技术 -->

    <div class="w100 hxjs">
      <div class="other1">
        <div v-for="(item,index) in cardMsg1" :key="index">
          <coreCard :cardMsg="item"></coreCard>
        </div>
      </div>
      <div class="other2">
        <div v-for="(item,index) in cardMsg2" :key="index">
          <coreCard :cardMsg="item"></coreCard>
        </div>
      </div>
    </div>

    <!-- 音频处理 -->
    <div
      class="yuyin"
      :style="{ background: 'url(' + require('@/assets/images/coretesc/js_bg_1.png') + ') no-repeat center center'}"
    >音频与语音信号处理技术</div>
    <div>
      <div class="yinpin1">
        <coreCardRight :cardMsg="cardMsg3"></coreCardRight>
      </div>
      <div class="yinpin2">
        <coreCardRight :cardMsg="cardMsg4"></coreCardRight>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from './Banner'
import TechnicalHighlights from '@/components/common/TechnicalHighlights'
import coreCard from '@/components/common/coreCard'
import coreCardRight from '@/components/common/coreCardRight'
export default {
  data () {
    return {
      techDes: [
        { 'title': '抗噪力强', 'context': ['具备复杂噪音 ', '多人讲话环境下的辨识能力'], 'img': 'images/coretesc/js_1.png' },
        { 'title': '稳定性高', 'context': ['跨语言和方言、跨多种信道', '对同一说话人进行识别达到高准确率'], 'img': 'images/coretesc/js_2.png' },
        { 'title': '安全可靠', 'context': ['能防范录音合成攻击'], 'img': 'images/coretesc/js_3.png' },
        { 'title': '响应迅速', 'context': ['毫秒级响应', '支持实时在线识别'], 'img': 'images/coretesc/js_4.png' }
      ],
      cardMsg1: [{
        'img': 'images/coretesc/sy_1.png',
        'h3': '语音活动检测技术',
        'p': ['提取音频文件中的语音片段'],
        'li': [
          '支持低信噪比和小时级音频文件提取秒级语音；', '支持多种复杂通信信道；', '支持多人说话语音切割提取；']
      }, {
        'img': 'images/coretesc/sy_2.png',
        'h3': '语音关键字定位',
        'p': ['从现场音频流或录音文件中自动检测指定关键字或短语的技术'],
        'li': [
          '基于全文识别结果的关键字索引搜索和基于关键字声学模型搜索，两种模式可单独或结合使用以提高识别精度；',
          '搜索的准确性仅取决于搜索词典的大小；', '响应时间快，可用于实时监控语音内容的场景；']
      }, {
        'img': 'images/coretesc/sy_3.png',
        'h3': '性别与年龄段识别技术',
        'p': ['能依据说话人语音特征自动判断说话人性别和年龄段'],
        'li': [
          '错误率低：自然说话下判定准确；',
          '识别迅速：可用于非接触式语音交流中用户快速画像；']
      }],
      cardMsg2: [{
        'img': 'images/coretesc/sy_4.png',
        'h3': '语音指令识别技术',
        'p': ['自动识别说话人指令，将语音指令转换成操作码'],
        'li': [
          '带身份的语音指令，可同时识别指令内容及其指令人权限；',
          '可通过语法配置，实现从词、短语到句子的识别；', '支持普通话和英语，可定制支持特定方言和语种；',
          '可创建特定应用程序的用户词典，以提高特定场景的单词和短语的识别准确性；']
      }, {
        'img': 'images/coretesc/sy_5.png',
        'h3': '语种、方言识别技术',
        'p': ['自动识别说话人所操语言和方言'],
        'li': [
          '支持十五种主流语言；',
          '提高了识别准确率，支持特殊高噪声信道；', '识别迅速，毫秒级响应，支持实时在线识别；']
      }],
      cardMsg3: {
        'img': 'images/coretesc/sy_7.png',
        'h3': ['语音降噪与增强技术'],
        'p': ['将语音音频中的背景噪声、信道噪声信号自动去除的技术，经过降噪处理可得到突出和', '增强的语音信号'],
        'li': [
          '能去除几十种连续或非连续、混响背景噪声，宽带或窄带信道噪声和压缩后失真;',
          '性能优异的图形化均衡处理算法和独特的噪声对消处理算法;', '可按场景灵活组合降噪算法模块;']
      },
      cardMsg4: {
        'img': 'images/coretesc/sy_8.png',
        'h3': ['音频处理与分析技术'],
        'p': ['音频数字化、可视化与变换处理，音频与语音特征提取、分析与展现'],
        'li': [
          '全面的音频信号处理，主要包括：归一化、改变幅度、截幅处理、重采样、改变位深度、调制、改变语速而不改变基本语调;',
          '丰富的音频可视化，主要包括：波形图、动态频谱图FFT和LPC、动态倒谱图、动态自相关图、平均光谱和瞬时光谱、音高轨迹、共振峰轨迹、信号能量、过零检测、直方图、元音散点图;',
          '音频特征提取，主要包括：频率响应，总谐波失真，幅度调制，采样率，背景噪声，信噪比，混响时间，截幅比例；',
          '语音特征提取，自动或辅助人工定位元音和提取声纹特征，如共振峰、音高；',
          '可用于音频真实性检验、语音质量评估、噪音分析、听觉分析、声纹同一性鉴定；']
      },
      bannerImgs: {
        'background': 'images/coretesc/hxjs_banner.png',
        'right': 'images/coretesc/hxjs_ct.png'
      }
    }
  },
  components: {
    TechnicalHighlights,
    Banner,
    coreCard,
    coreCardRight
  }
}
</script>

<style scoped>
.flexslider {
  position: relative;
  height: 584px;
  overflow: hidden;
  z-index: 1;
  clear: both;
  margin-top: -65px;
}
.bannerFather /deep/ .banner {
  margin-top: 45px;
  width: 42%;
}
.swsb {
  background: url(../../../assets/images/sw_bg.png) no-repeat;
  background-size: 100% 100%;
}

.swsb .container h2 {
  font-weight: bold;
  line-height: 50px;
  margin-bottom: 47px;
  font-size: 70px;
  font-weight: bold;
  color: rgba(74, 17, 118, 1);
}
.swsb .container p {
  font-size: 38px;
  font-weight: normal;
  color: rgba(51, 51, 51, 1);
  margin-top: 70px;
}
/* 算法特点*/
.floatitem > div {
  height: 180px;
  font-size: 16px;
  line-height: 33px;
  font-weight: 400;
  padding: 25px 29px 0 48px;
}
.floatcontent {
  width: 940px;
}
/* 其他核心技术开始 */
.imgborder img {
  margin-top: -15px;
  width: 140px;
}
.technical /deep/ #fa {
  background: rgba(248, 248, 248, 1);
  padding-top: 92px;
}
.technical /deep/ .item div {
  width: 255px;
}
/* 语音技术开始 */
.other1 {
  margin: 0 auto;
  width: 1250px;
  height: 520px;
}
.other1 > div {
  float: left;
  margin-left: 38px;
  margin-top: 35px;
}
.other1 /deep/ .app {
  min-height: 521px;
}
.other1 /deep/ .context .item-core {
  width: 375px;
}
.other1 /deep/ .context .item-core :nth-child(2) {
  width: 295px;
}
.other2 /deep/ .context .item-core {
  width: 375px;
}
.other2 {
  margin: 0 auto;
  width: 896px;
  height: 560px;
  margin-bottom: 160px;
}
.other2 > div {
  float: left;
  /* margin-right: 38px; */
  margin-left: 38px;
  margin-top: 35px;
}
.other2 /deep/ .app {
  min-height: 550px;
  width: 400px;
}
.other2 /deep/ .context .item-core :nth-child(2) {
  width: 320px;
}
.yuyin {
  font-size: 60px;
  font-weight: bold;
  height: 300px;
  line-height: 300px;
  color: rgba(255, 255, 255, 1);
  background: linear-gradient(
    88deg,
    rgba(58, 30, 90, 1) 0%,
    rgba(31, 12, 52, 1) 100%
  );
}
/* 语音技术结束 */
/* 音频处理技术开始 */
.yinpin1 {
  margin-top: 50px;
}
.yinpin1 /deep/ .context .item-core :nth-child(2) {
  width: 660px;
}
.yinpin1 /deep/ .app {
  height: 285px;
}
.yinpin1 /deep/ .title p {
  width: 800px;
}
.yinpin2 {
  margin-top: 40px;
  margin-bottom: 100px;
}
.yinpin2 /deep/ .context .item-core {
  width: 759px;
}
.yinpin2 /deep/ .context .item-core :nth-child(2) {
  width: 660px;
}
.yinpin2 /deep/ .app {
  height: 430px;
}
.yinpin1 /deep/ .title h3,
.yinpin2 /deep/ .title h3 {
  color: #333333;
}
/* 音频处理技术结束 */
/* 其他核心技术结束 */

/* .ys { */
/* width:1920px;
height:608px;
background:rgba(248,248,248,1); */
/* } */
/* 场景 */
.cjapply1 {
  background: url(../../../assets/images/chanpin/rs_bot1.png) no-repeat;
  z-index: 1;
  background-size: 100% 100%;
  width: 47.6%;
  height: 264px;
  padding-top: 105px;
  margin: 0;
}
.cjapply2 {
  width: 47.6%;
  height: 264px;
  padding-top: 105px;
  margin: 0;
  background: url(../../../assets/images/chanpin/rs_bot2.png) no-repeat;
  z-index: 1;
  background-size: 100% 100%;
}
.submitform {
  width: 40%;
  margin-left: 30%;
}
.hxjs .outcontainer {
  width: 62.4%;
  min-width: 1090px;
  display: block;
  padding: 87px 0 68px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/coreTechnology/coreTechnology.vue